import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var GeonexAPIError = /*#__PURE__*/function (_Error) {
  function GeonexAPIError(status, statusText, body, context) {
    var _this;
    _classCallCheck(this, GeonexAPIError);
    _this = _callSuper(this, GeonexAPIError, ["Failed to fetch ".concat(context, ": ").concat(status, " ").concat(statusText, " - ").concat(body)]);
    _defineProperty(_this, "status", void 0);
    _defineProperty(_this, "statusText", void 0);
    _defineProperty(_this, "body", void 0);
    console.warn("Failed to fetch ".concat(context, ": ").concat(status, " ").concat(statusText, " - ").concat(body));
    _this.status = status;
    _this.statusText = statusText;
    _this.body = body;
    return _this;
  }
  _inherits(GeonexAPIError, _Error);
  return _createClass(GeonexAPIError);
}(/*#__PURE__*/_wrapNativeSuper(Error));